<script setup lang="ts">
import { computed } from 'vue';

type Emits = {
  (e: 'click'): void;
  (e: 'click:close'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  icon?: string;
  label?: string;
  size?: string;
  isSelected?: boolean;
  isLoading?: boolean;
  count?: string | number;
  color?: string;
  textColor?: string;
};

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  label: undefined,
  size: undefined,
  isSelected: false,
  isLoading: false,
  count: undefined,
  color: undefined,
  textColor: undefined,
});

const color = computed(() => {
  if (props.color) {
    return props.color;
  }
  return props.isSelected ? 'bg-primary-container' : 'bg-secondary-container';
});
const handleClick = () => {
  if (props.isSelected) {
    emit('click:close');
    return;
  }
  emit('click');
};
</script>

<template>
  <v-btn
    class="ma-2 rounded-lg text-none"
    :size="size"
    :class="color"
    :color="textColor ?? 'on-surface'"
    :append-icon="isSelected && !isLoading ? 'mdi-close' : undefined"
    :prepend-icon="icon"
    :aria-label="label"
    label
    variant="flat"
    @click="handleClick"
  >
    <slot>
      <span>
        <span v-if="label">{{ label }}</span>
        <span v-if="count" class="pl-1"> ({{ count }})</span>
        <v-progress-circular
          v-else-if="!count && isLoading"
          color="primary"
          size="18"
          width="2"
          class="ml-1"
          indeterminate
        />
      </span>
    </slot>
  </v-btn>
</template>

<style scoped lang="scss">
:deep(.v-btn__content) {
  flex-wrap: wrap !important;
}
:deep(.v-btn__underlay) {
  opacity: 0;
}
.v-btn {
  min-height: 32px;
  height: auto !important;
}
</style>
